import styled from 'styled-components';
import { styledParagraph, Typography } from './BaseTypes';
import { styledMargin } from '../layout/Margin';

export const B2 = styled.p<Typography>`
  ${styledParagraph}
  ${styledMargin}
  font-size: 16px;
`;
